export const FACEBOOK_URL = 'https://www.facebook.com/JuridikaUF/'
export const INSTAGRAM_URL = 'https://www.instagram.com/juridika_/'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/juridika/'
export const HELP_CENTER_URL = 'https://innhold.juridika.no/hjelpesider'
export const BECOME_AN_AUTHOR_URL = 'https://www.universitetsforlaget.no/forfatter/bli-forfatter'
export const HOMEPAGE_URL = '/'

export const PAGE_ID_QUERY = 'pageId'
